/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Filters from "../../../components/Filters";
import { ControlTable } from "../../../components/Table";
import { getDay } from "../../../utils/date";
import { getParams, getExcelDownParams } from "../../../utils/params";
import { excelUploadModifyBalances, getBondDebtsClientsSumaaries, getBondDeptsClientSummariesExcel, getClientsExcelFile } from "../../../apis/bond-debts";
import BondDebt from "./BondDebt";
import useForm from "../../../hooks/useForm";
import BondDebtBaseAmt from "./BondDebtBaseAmt";
import { findIndex, isEmpty } from "lodash";
import PageHeader from "../../../components/PageHeader";
import { downExcelFile } from "../../../utils/download";
import { calcPreBalance } from "../../../utils/bond-debt";
import Modal, { ModalHeader } from "../../../components/Modal";
import { ModalBody } from "reactstrap";
import { Col, Row } from "../../../components/ContentLayout";
import { isUndefined } from "lodash";
import systemAlert from "../../../utils/systemAlert";
import { viewLoading } from "../../../utils/loading";
import DataComponent from "../../../components/DataComponent";
import { preventEvent } from "../../../utils/element";
import { clientPreview } from "../../../utils/client";
import { get } from "lodash";

const FundsBondDebt = (props) => {
  const { company } = useSelector((store) => store.Profile);

  const { type, activeTab, tabList } = props;
  const [sortFields, setSortFields] = useState([
    { key: 'name', order: '' },
    { key: 'baseAmt', order: '' },
    { key: 'balance', order: '' },
    { key: 'salesAmt', order: '' },
    { key: 'purchaseAmt', order: '' },
    { key: 'accountInAmt', order: '' },
    { key: 'accountOutAmt', order: '' },
    { key: 'issuedSalesAmt', order: '' },
    { key: 'issuedPurchaseAmt', order: '' },
  ]);
  const [fields, setFields] = useState([]);
  const [open, setOpen] = useState(false);
  const [rowData, setRowData] = useState({});
  const [isBaseAmtOpen, setIsBaseAmtOpen] = useState(false);
  const [baseAmtData, setBaseAmtData] = useState(null);
  const [isExcelUploadModal, setIsExcelUploadModal] = useState(false);


  useEffect(() => {
    setFields([
      {
        title: "거래처명", key: "client.name", sortKey: 'name', sort: () => handleSort('name'), order: () => orderKey('name'),
        onValue: (v, _f, d) => {
          return <p
            onClick={(e) => {
              preventEvent(e);
              d?.client?.companyAccount && clientPreview(d.client.companyAccount.idx);
            }}

          >{v}</p>;
        }
      },
      {
        title: "그룹명", key: "client.companyAccount",
        onValue: (v, _f, _d) => {
          const groups = get(v, "companyAccountGroups", []);
          return !isEmpty(groups) ? (
            groups.map((item, idx) => {
              return (
                <p className="pt-8 pb-8" key={idx}>
                  <span className="vertical-middle">
                    {item.name}
                  </span>
                </p>
              );
            })

          ) : "";
        }
      },
      { title: '사업자번호', key: 'client.companyAccount.comNum', transform: 'comNum' },
      { title: "코드", key: "client.companyAccount.code" },
      // {
      //   title: "기초잔액",
      //   key: "client.bondDebtBaseAmt",
      //   type: 'comma',
      //   sortKey: 'baseAmt',
      //   sort: () => handleSort('baseAmt'), order: () => orderKey('baseAmt')
      // },
      {
        title: "이월",
        key: "preBalanceAmt",
        type: 'comma',
        onValue: (value, field, data) => {
          return `${calcPreBalance(data, type)}`;
        }
      },
      {
        title: type === "invoice" ? "거래명세서 매출" : "발행매출",
        key: type === "invoice" ? "totalSalesAmt" : "totalIssuedSalesAmt",
        sortKey: type === "invoice" ? "salesAmt" : "issuedSalesAmt",
        type: 'comma',
        sort: () => handleSort(type === "invoice" ? "salesAmt" : "issuedSalesAmt"), order: () => orderKey(type === "invoice" ? "salesAmt" : "issuedSalesAmt")
      },
      {
        title: type === "invoice" ? "거래명세서 매입" : "발행매입",
        key: type === "invoice" ? "totalPurchaseAmt" : "totalIssuedPurchaseAmt",
        sortKey: type === "invoice" ? "purchaseAmt" : "issuedPurchaseAmt",
        type: 'comma',
        sort: () => handleSort(type === "invoice" ? "purchaseAmt" : "issuedPurchaseAmt"), order: () => orderKey(type === "invoice" ? "purchaseAmt" : "issuedPurchaseAmt")
      },
      {
        title: "입금",
        key: "totalAccountInAmt",
        sortKey: 'accountInAmt',
        type: 'comma',
        className: 'color-red-100',
        sort: () => handleSort('accountInAmt'), order: () => orderKey('accountInAmt')
      },
      {
        title: "출금",
        key: "totalAccountOutAmt",
        sortKey: 'accountOutAmt',
        type: 'comma',
        className: 'color-purple-100',
        sort: () => handleSort('accountOutAmt'), order: () => orderKey('accountOutAmt')
      },
      {
        title: "잔액",
        key: "balanceAmt",
        sortKey: 'balance',
        type: 'comma',
        sort: () => handleSort('balance'), order: () => orderKey('balance')
      },
      {
        title: type === "invoice" ? "발행매출" : "거래명세서 매출",
        key: type === "invoice" ? "totalIssuedSalesAmt" : "totalSalesAmt",
        // sortKey: type === "invoice" ? "issuedSalesAmt" : "salesAmt",
        type: "comma",
        // sort: () => handleSort(type === "invoice" ? "issuedSalesAmt" : "salesAmt"), order: () => orderKey(type === "invoice" ? "issuedSalesAmt" : "salesAmt")
      },
      {
        title: type === "invoice" ? "발행매입" : "거래명세서 매입",
        key: type === "invoice" ? "totalIssuedPurchaseAmt" : "totalPurchaseAmt",
        // sortKey: type === "invoice" ? "issuedPurchaseAmt" : "purchaseAmt",
        type: "comma",
        // sort: () => handleSort(type === "invoice" ? "issuedPurchaseAmt" : "purchaseAmt"), order: () => orderKey(type === "invoice" ? "issuedPurchaseAmt" : "purchaseAmt")
      },
    ]);
  }, [type, sortFields]);

  const {
    form,
    setForm,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reSubmit,
    setOrderBy
  } = useForm(
    {
      type,
      zeroBalance: false,
      range: {
        trDate: [getDay(7), getDay()]
      },
      search: {
        name: '',
      },
      page: 0,
      limit: 10
    }
  );

  useEffect(() => {
    const sortField = sortFields.find((field) => !isEmpty(field.order));
    if (sortField) {
      setOrderBy(sortField);
    }
  }, [sortFields]);

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);

  const submit = (params) => {
    const _params = getParams({
      ...params,
      zeroBalance: !params.zeroBalance
    });
    if (_params.zeroBalance) {
      delete _params.zeroBalance;
    }

    setIsLoading(true);


    // 타입 "invoice" , "issued"
    // 매출 "totalIssuedSalesAmt" : "totalSalesAmt"
    // 매입 "totalIssuedPurchaseAmt" : "totalPurchaseAmt"
    // 거래명세서 기준 발행내역 기준 임시 처리
    getBondDebtsClientsSumaaries(_params)
      .then((res) => {
        const datas = res.data.summaries;
        setList(datas);
        setTotal(res.data.totalCount);
        /*
        const clientIdxes = datas.map((a) => a.clientIdx)
        getBondDebtsClientsSumaaries({
          ..._params,
          clientIdxes,
          type: type === 'invoice' ? 'issued' : 'invoice'
        })
          .then((res2) => {
            const datas2 = res2.data.summaries
            datas.forEach(data => {
              const idx = data.clientIdx
              const data2 = datas2.find(i => i.clientIdx === idx)
              const key1 = type === 'invoice' ? "totalIssuedSalesAmt" : "totalSalesAmt"
              const key2 = type === 'invoice' ? "totalIssuedPurchaseAmt" : "totalPurchaseAmt"
              if (data2) {
                data[key1] = data2[key1]
                data[key2] = data2[key2]
              }
            });
            console.log('=====================================')
            console.log(datas)
            setList(datas);
            setTotal(res.data.totalCount);
          })
        */
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const filterConfig = [
    {
      title: "조회기간",
      key: "range.trDate",
      type: "customdatepicker",
    },
    {
      title: '거래처명',
      key: 'search.name',
      type: 'input'
    },
    {
      title: '거래처 그룹명',
      key: 'search.groupName',
      type: 'input'
    },
    {
      title: "잔액 0원 표시안함",
      type: "checkbox",
      key: "zeroBalance",
      label: "",
      checked: form.zeroBalance,
      onChange: (checked) => {
        setForm({
          ...form,
          zeroBalance: checked
        });
      }
    },
  ];

  const handleRowClick = (data) => {
    setRowData(data);
    setOpen(true);
  };

  const rowBtnConfig = {
    title: '기초잔액',
    rowButtons: [
      {
        label: "수정",
        type: "edit",
        action: (data) => {
          setIsBaseAmtOpen(true);
          setBaseAmtData(data);
        },
      },
    ],
  };

  const handleSort = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    const idx = findIndex(sortFields, sortField);
    let newArray = [...sortFields.map((field) => ({
      ...field,
      order: field.key !== key ? '' : field.order
    }))];
    newArray[idx] = {
      key,
      order: newArray[idx].order !== 'desc' ? 'desc' : 'asc'
    };
    setSortFields(newArray);
  };

  const orderKey = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    return sortField.order;
  };

  const headerButtons = [
    {
      color: "gray-line",
      label: "엑셀업로드",
      action: () => {
        setIsExcelUploadModal(true);
      }
    },
    {
      color: "gray-line",
      label: (
        <>
          엑셀다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {

        const from = form.range.trDate[0];
        const to = form.range.trDate[1];
        /*
        const body = {
          range: {
            trDate: {
              from,
              to,
            },
          },
          type: form.type,
        }
        if (form.search && form.search.name) {
          body.search = form.search
        }
        if (form.order) {
          body.order = form.order
        }
        if (form.zeroBalance) {
          body.zeroBalance = !form.zeroBalance
        }
        */
        const _params = getExcelDownParams({
          ...form,
          zeroBalance: !form.zeroBalance
        });
        if (_params.zeroBalance) {
          delete _params.zeroBalance;
        }
        viewLoading("엑셀 다운로드 중입니다.");
        getBondDeptsClientSummariesExcel(_params).then((res) => {
          let title = '';
          let comName = '';
          if (company && !isEmpty(company)) {
            comName = company.name + '_';
          }
          if (_params.type === 'invoice') {
            title = comName + `거래처별채권채무_거래명세서기준[${from}~${to}].xlsx`;
          } else {
            title = comName + `거래처별채권채무_발행내역기준[${from}~${to}].xlsx`;
          }
          downExcelFile(res, title);
          viewLoading(false);
        });
      },
    },
  ];

  const uploadExcelFile = (e) => {
    const file = e.target.files[0];

    if (!isUndefined(file)) {
      systemAlert(`"${file.name}" 파일을 업로드 하시겠습니까?`, {
        buttons: [
          {
            color: "text",
            label: "취소",
          },
          {
            label: "확인",
            onClick: () => {
              viewLoading("기초잔액 일괄수정중 입니다.");
              const formData = new FormData();
              formData.append("file", file);

              excelUploadModifyBalances(formData)
                .then(() => {
                  setOpen(false);
                  systemAlert('기초잔액 일괄수정이 완료되었습니다.');
                  window.location.reload();
                })
                .finally(() => {
                  viewLoading(false);
                });
            },
          },
        ],
      });
    }

  };

  const excelUploadButtons = [
    {
      color: "text",
      size: "sm",
      type: 'button',
      label: (
        <>
          거래처 목록 다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        viewLoading("엑셀 다운로드 중입니다.");
        getClientsExcelFile().then((res) => {
          let title = `거래처 목록.xlsx`;
          if (company && !isEmpty(company)) {
            title = company.name + '_' + title;
          }
          downExcelFile(res, title);
        }).finally(() => {
          viewLoading(false);
        });

      },
    },
    {
      // isHide: activeTab === 'purchases' || (targetPermission && targetPermission.level <= 1),
      label: `거래처 기초잔액 일괄수정`,
      color: "gray-line",
      size: "sm",
      type: "excelfile",
      onChange: (e) => uploadExcelFile(e),
    },
  ];

  return (
    <>
      <PageHeader title={"거래처별 채권채무"}
        activeTab={activeTab}
        tabList={tabList}
        buttons={headerButtons}
      />
      <Filters
        isLoading={isLoading}
        filters={filterConfig}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        isLoading={isLoading}
        fields={fields}
        sortField={sortFields.find((field) => !isEmpty(field.order))}
        list={list}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        onSelect={handleRowClick}
        submit={handleSubmit}
        rowBtn={rowBtnConfig}
      />
      {open && (
        <BondDebt
          open={open}
          setOpen={setOpen}
          data={rowData}
          filterParams={form}
          type={type}
        />
      )}
      {isBaseAmtOpen && (
        <BondDebtBaseAmt
          open={isBaseAmtOpen}
          setOpen={setIsBaseAmtOpen}
          data={baseAmtData}
          setData={setBaseAmtData}
          submit={() => reSubmit(form)}
        />
      )}

      <Modal size="md" isOpen={isExcelUploadModal} close={() => setIsExcelUploadModal(false)}>
        <ModalHeader>엑셀 업로드</ModalHeader>
        <ModalBody>

          <Row>
            <Col>
              <p>거래처 정보는 수정할 수 없습니다.</p>
              <p>거래처 코드와 거래처 명으로 거래처를 구분합니다.</p>
              <p>거래처 목록 다운로드 후 기초잔액만 수정하여 업로드 하시면 됩니다.</p>
            </Col>
            <Col style={{ textAlign: 'center', }} >
              {excelUploadButtons.map((item, key) => {
                return (
                  <DataComponent field={item} key={key} />
                );
              })}
            </Col>
          </Row>

        </ModalBody>
      </Modal>
    </>
  );
};

export default FundsBondDebt;
